import { gql } from "@apollo/client";

export const GET_AUTHENTICATION_STATE = gql`
  query GetAuthenticationState {
    authenticationState @client {
      authenticated
      user
      selectedAccount
      accounts
    }
  }
`;
